module.exports = __webpack_public_path__ + "static/media/pin-warning-viajes.cf2978d0.png";